import {
    PARTNER_AGENT_CREATE_FAIL,
    PARTNER_AGENT_CREATE_REQUEST,
    PARTNER_AGENT_CREATE_SUCCESS,
    PARTNER_AGENT_GET_FAIL,
    PARTNER_AGENT_GET_REQUEST,
    PARTNER_AGENT_GET_SUCCESS,
    PARTNER_AGENT_LIST_FAIL,
    PARTNER_AGENT_LIST_REQUEST,
    PARTNER_AGENT_LIST_SUCCESS,
    PARTNER_AGENT_UPDATE_FAIL,
    PARTNER_AGENT_UPDATE_REQUEST,
    PARTNER_AGENT_UPDATE_SUCCESS,
} from '../constants/partnerAgentConstants'
import api from '../core/api'

export const createPartnerAgent = (parm) => async (dispatch, getState) => {
    try {
        dispatch({ type: PARTNER_AGENT_CREATE_REQUEST })
        const { data } = await api.post(
            "/partneragent",
            parm
        )

        var dt = data.Result
        if(dt.includes("Error")){
            dispatch({
                type: PARTNER_AGENT_CREATE_FAIL,
                payload: data.Result.replace('Error - ', '')
            })
        }else{
            dispatch({
                type: PARTNER_AGENT_CREATE_SUCCESS,
                payload: data.Result
            })
        }
    } catch (error) {
        dispatch({
            type: PARTNER_AGENT_CREATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const listPartnerAgents = () => async (dispatch, getState) => {
    try {
        dispatch({ type: PARTNER_AGENT_LIST_REQUEST })

        const { data } = await api.get(
            "/partneragent"
        )

        var dt = data.Result;
        if(typeof (dt) == 'string'){
            dispatch({
                type: PARTNER_AGENT_LIST_FAIL,
                payload: data.Result
            })
        }else{
            dispatch({
                type: PARTNER_AGENT_LIST_SUCCESS,
                payload: data.Result
            })
        }
        
    } catch (error) {
        dispatch({
            type: PARTNER_AGENT_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const getPartnerAgent = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: PARTNER_AGENT_GET_REQUEST })

        const { data } = await api.get(
            "/partneragent/" + id
        )

        var dt = data.Result;
        if(typeof (dt) == 'string'){
            dispatch({
                type: PARTNER_AGENT_GET_FAIL,
                payload: data.Result
            })
        }else{
            dispatch({
                type: PARTNER_AGENT_GET_SUCCESS,
                payload: data.Result
            })
        }
        
    } catch (error) {
        dispatch({
            type: PARTNER_AGENT_GET_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const updatePartnerAgent = (id, parm) => async (dispatch, getState) => {
    try {
        dispatch({ type: PARTNER_AGENT_UPDATE_REQUEST })

        const { data } = await api.put(
            "/partneragent/" + id,
            parm
        )

        var dt = data.Result
        if(dt.includes("Error")){
            dispatch({
                type: PARTNER_AGENT_UPDATE_FAIL,
                payload: data.Result.replace('Error - ', '')
            })
        }else{
            dispatch({
                type: PARTNER_AGENT_UPDATE_SUCCESS,
                payload: data.Result
            })
        }
    } catch (error) {
        dispatch({
            type: PARTNER_AGENT_UPDATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}